import { Box, Tab } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useAuth } from "../contexts/AuthContext";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { roles } from "../firebase.collection";
import { showCustomToast } from "./Misc/CustomToast";
import Admin from "./ClientsCategory/Admin";
import { LanguageContext } from "../context/LanguageContext";
import PreAdmissionMobileV2 from "./PreAdmissionMobileV2";
import GeneralInformationV2 from "./ClientsCategory/GeneralInformationV2";
import FormsMobileV2 from "./ClientsCategory/FormsMobileV2";
import ClinicalInformationsMobileV2 from "./ClientsCategory/ClinicalInformationsMobileV2";
import AllNotesPerClientContainerMobileV2 from "./containers/AllNotesPerClientContainerMobileV2";
import UploadMobileV2 from "./ClientsCategory/UploadMobileV2";
import AlertsMobileV2 from "./ClientsCategory/AlertsMobileV2";

function ClientProfilTabMobileV2(props) {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";
  // const [value, setValue] = useState("2");
  const [value, setValue] = useState(props.selectedTab || "2");
  const [userRole, setUserRole] = useState("");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const handleModificationChange = (isModified) => {
    setHasUnsavedChanges(isModified);
  };

  const handleChange = (event, newValue) => {
    if (["1", "2", "4"].includes(value) && hasUnsavedChanges) {
      showCustomToast("Don't forget to save your modification!", "error");
    } else {
      setValue(newValue);
    }
  };

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div className="tab-client-container">
      <Box>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              width: "auto",
              paddingLeft: "0px",
              marginTop: "0px",
            }}
          >
            <TabList
              aria-label="Tabs example"
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab label={translate("GeneralInformation")} value="2" />
              <Tab label={translate("PreAdmissionAssessment")} value="1" />
              {userRole !== "Admission staff" &&
              userRole !== "Hospitality Staff" ? (
                <Tab label={translate("AdmissionForms")} value="3" />
              ) : (
                ""
              )}
              {userRole !== "Admission staff" &&
              userRole !== "Hospitality Staff" ? (
                <Tab label={translate("ClinicalInformations")} value="4" />
              ) : (
                ""
              )}
              {userRole !== "Admission staff" ? (
                <Tab label={translate("Notes")} value="5" />
              ) : (
                ""
              )}
              {/* {userRole !== "Admission staff" ? (
                <Tab label="Discharge & Ongoing care" value="6" />
              ) : (
                ""
              )} */}
              <Tab label={translate("UPLOAD")} value="7" />
              <Tab label={translate("Alerts")} value="8" />
              {/* {(userRole === "Super Admin" ||
                userRole === "Admin" ||
                userRole === "Clinical Director") && (
                <Tab label="Admin" value="9" />
              )} */}
            </TabList>
          </Box>
          {(() => {
            switch (value) {
              case "1":
                return (
                  <TabPanel value="1" style={{ paddingLeft: 0 }}>
                    <PreAdmissionMobileV2
                      onModificationChange={handleModificationChange}
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );
              case "2":
                return (
                  <TabPanel value="2" style={{ paddingLeft: 0 }}>
                    <GeneralInformationV2
                      onModificationChange={handleModificationChange}
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );
              case "3":
                return (
                  <TabPanel value="3" style={{ paddingLeft: 0 }}>
                    <FormsMobileV2 clientId={props.clientId} {...props} />
                  </TabPanel>
                );
              case "4":
                return (
                  <TabPanel value="4" style={{ paddingLeft: 0 }}>
                    <ClinicalInformationsMobileV2
                      onModificationChange={handleModificationChange}
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );
              case "5":
                return (
                  <TabPanel value="5" style={{ paddingLeft: 0 }}>
                    <AllNotesPerClientContainerMobileV2
                      userId={props.clientId}
                      {...props}
                    />
                    {/* <ClientNotes clientId={props.clientId} {...props} /> */}
                  </TabPanel>
                );
              // case "6":
              //   return (
              //     <TabPanel value="6" style={{ paddingLeft: 0 }}>
              //       <SwotsMobileV2 clientId={props.clientId} {...props} />
              //     </TabPanel>
              //   );
              case "7":
                return (
                  <TabPanel value="7" style={{ paddingLeft: 0 }}>
                    <UploadMobileV2 clientId={props.clientId} {...props} />
                  </TabPanel>
                );

              case "8":
                return (
                  <TabPanel value="8" style={{ paddingLeft: 0 }}>
                    <AlertsMobileV2
                      clientId={props.clientId}
                      clientIdentifier={props.clientIdentifier}
                      {...props}
                    />
                  </TabPanel>
                );
              case "9":
                return (
                  <TabPanel value="9" style={{ paddingLeft: 0 }}>
                    <Admin
                      clientId={props.clientId}
                      clientIdentifier={props.clientIdentifier}
                      {...props}
                    />
                  </TabPanel>
                );
              default:
                return null;
            }
          })()}
        </TabContext>
      </Box>
    </div>
  );
}

export default ClientProfilTabMobileV2;
